module.exports = __webpack_public_path__ + "static/media/iShowGIF.67af7a47.gif";